export default {
  settings: {
    title: "Paramètres",
    subtitle: "Gérez votre compte et vos préférences",
    nav: {
      profile: "Mon Profil & Couple",
      wedding: "Détails du Mariage",
      event: "Détails de l'événement",
      collaborators: "Collaborateurs",
      notifications: "Notifications",
      appearance: "Apparence & Langue",
      subscription: "Abonnement",
      security: "Sécurité"
    },
    groups: {
      account: "Compte",
      event: "Événement",
      preferences: "Préférences"
    },
    general: {
      title: "Mon Profil & Couple",
      description: "Gérez vos informations personnelles et celles de votre partenaire.",
      me: "Moi",
      partner: "Mon Partenaire",
      partnerHelp: "Invitez votre partenaire à rejoindre la gestion du mariage."
    },
    wedding: {
      title: "Détails du Mariage",
      description: "Informations essentielles sur votre événement."
    },
    appearance: {
      title: "Apparence & Langue",
      description: "Personnalisez votre expérience.",
      languages: {
        fr: "Français",
        en: "Anglais",
        es: "Espagnol",
        de: "Allemand",
        it: "Italien"
      }
    },
    notifications: {
      email: {
        title: "Notifications par email",
        description: "Recevez les mises à jour importantes et les rappels par email"
      },
      push: {
        title: "Notifications push",
        description: "Recevez des alertes en temps réel sur votre navigateur"
      },
      title: "Notifications",
      description: "Choisissez comment et quand vous souhaitez être notifié.",
      enable: "Activer les notifications",
      enableDesc: "Recevoir des alertes pour les événements importants",
      types: "Types de notifications",
      reminderTiming: "Délai de rappel par défaut",
      hoursBefore: "{{count}}h avant",
      quietHours: "Heures calmes",
      start: "Début",
      end: "Fin",
      labels: {
        tasks: "Tâches",
        guests: "Invités",
        budget: "Budget",
        system: "Système"
      },
      error: "Erreur lors du chargement des paramètres de notification"
    },
    security: {
      title: "Sécurité",
      description: "Gérez votre mot de passe et vos sessions.",
      status: "État du compte",
      verified: "Votre email est vérifié.",
      unverified: "Votre email n'est pas vérifié.",
      sessions: "Sessions actives",
      dangerZone: "Zone de danger",
      deleteAccount: "Supprimer le compte",
      deleteAccountHelp: "Cette action est irréversible."
    },
    collaborators: {
      title: "Gestion du partage",
      invitationsTitle: "Invitations de partage",
      noWedding: "Aucun mariage trouvé",
      loadError: "Une erreur est survenue lors du chargement du mariage",
      invitationsError: "Une erreur est survenue lors du chargement des invitations",
      noInvitations: "Aucune invitation trouvée",
      noInvitationsDesc: "Les invitations de partage apparaîtront ici une fois créées",
      expiresAt: "Expire le: {{date}}",
      accessCode: "Code d'accès: {{code}}",
      infoMessage: "Cette page affiche les invitations de partage envoyées. Pour créer de nouvelles invitations ou gérer les collaborateurs, utilisez le composant ShareManagement dans les paramètres de votre événement.",
      status: {
        pending: "En attente",
        accepted: "Acceptée",
        declined: "Refusée",
        expired: "Expirée"
      },
      resourceTypes: {
        tasks: "Tâches",
        guests: "Invités",
        budget: "Budget",
        timeline: "Planning",
        tasksAndGuests: "Tâches et Invités"
      }
    },
    subscription: {
      title: "Abonnement & Facturation",
      description: "Gérez votre plan et suivez votre utilisation.",
      invoices: "Factures",
      noInvoices: "Aucune facture disponible",
      upgrade: "Passer Premium",
      features: {
        oneEvent: "1 Événement",
        basicGuests: "Liste d'invités basique",
        limitedTasks: "Tâches limitées",
        unlimitedEvents: "Événements illimités",
        unlimitedGuests: "Invités illimités",
        export: "Export PDF & Excel",
        seating: "Plan de table avancé",
        budget: "Budget & Analyses",
        support: "Support prioritaire"
      },
      proDescription: "Profitez de toutes les fonctionnalités sans limites.",
      freeDescription: "Passez à la version Premium pour débloquer toutes les fonctionnalités."
    },
    theme: "Thème",
    placeholders: {
      exampleName: "Ex: Marie Dupont",
      exampleVenue: "Ex: Château de Versailles"
    },
    language: "Langue",
    languageDescription: "Choisissez la langue de l'interface",
    account: {
      export: {
        button: "Exporter mes données",
        loading: "Export en cours..."
      },
      errors: {
        exportData: "Erreur lors de l'export des données",
        deleteAccount: "Erreur lors de la suppression du compte"
      }
    },
    export: {
      title: "Exporter mes données",
      description: "Téléchargez une copie de toutes vos données (invités, tâches, budget, etc.)",
      gdprNotice: "Conformément au RGPD, vous pouvez récupérer l'intégralité de vos données personnelles."
    },
    delete: {
      title: "Supprimer mon compte",
      description: "Cette action est irréversible. Toutes vos données seront définitivement effacées.",
      confirmTitle: "Supprimer mon compte ?",
      confirmDescription: "Êtes-vous sûr de vouloir supprimer définitivement votre compte ? Toutes vos données seront perdues.",
      confirmButton: "Supprimer définitivement"
    },
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    partnerName: "Nom complet",
    partnerEmail: "Email (pour invitation)",
    weddingDate: "Date du mariage",
    location: "Lieu & Localisation",
    venue: "Lieu de réception",
    country: "Pays",
    city: "Ville",
    guestCount: "Nombre d'invités estimé",
    password: "Mot de passe",
    passwordHelp: "Dernière modification il y a 3 mois",
    changePassword: "Modifier",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe"
  }
};